import "../css/NavCss.css";
import { PiWhatsappLogo } from "react-icons/pi";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";

function NavBar() {
  return (
    <div>
      <ul className="listNav">
        <li className="contList">Sobre min</li>
        <li className="contList">Projetos</li>
        <li className="contList">Contato</li>
      </ul>
      
      <ul className="logoRs">
        <li className="lg">
          <a href="https://api.whatsapp.com/send?phone=5586994712598&text=Ol%C3%A1,%20gostaria%20de%20fazer%20um%20or%C3%A7amento.">
            {" "}
            <PiWhatsappLogo />
          </a>
        </li>
        <li className="lg">
          <a href="https://instagram.com/dev_rms?igshid=MzMyNGUyNmU2YQ==">
            {" "}
            <FaInstagram />
          </a>
        </li>
        <li className="lg">
          <a href="https://www.linkedin.com/in/romenson-cleiton-87834b232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app">
            {" "}
            <FaLinkedin />
          </a>
        </li>
      </ul>
      
    </div>
  );
}

export default NavBar;
